<template>
    <b-card no-body class="p-3" v-loading="is_loading">
        <b-row>
            <b-col class="border-right">
                <p>Disbursement Status</p>
                <h4 :class="currentStatus.color_class">{{ currentStatus.name }}</h4>
            </b-col>
						<b-col class="border-right">
							<p>Full Disbursement Date</p>
							<el-popover
								placement="top"
								width="300"
								trigger="click">
								<b-form-group label="Full Disbursement Date">
										<el-date-picker
										v-model="form.disb_full_date"
										value-format="yyyy-MM-dd"
										type="date"
										placeholder="Pick a day"
										@change="updateFullDisbDate"
										>
										</el-date-picker>
								</b-form-group>
								<div slot="reference" class="d-flex align-items-start cursor-pointer">
									<p class="font-weight-600 mr-2"><u>{{ activeCase.disb_full_date || "-" | dateFormatString }}</u></p>
								</div>
							</el-popover>
						</b-col>
            <b-col class="border-right">
                <p>Total Disbursed Amt (RM)</p>
                <h4>{{ activeCase.disb_done_amt | moneyFormatter }}</h4>
            </b-col>
            <b-col>
                <p>Remaining Amount (RM)</p>
                <h4 :class="{ 'text-danger': remaining_amount < 0 }">{{ remaining_amount | moneyFormatter }}</h4>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
import { Popover, DatePicker, Button } from 'element-ui'
import { swal } from '@/assets/js/httpImports.js';
import {cloneDeep} from 'lodash'
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { mapState, mapActions } from 'pinia';
import { useCommonStore } from '@/stores/commonStore'
import { useApprovalStore } from '@/stores/approvalStore';
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore';
import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'

export default {
	components: {
		[Button.name]: Button,
		[DatePicker.name]: DatePicker,
		[Popover.name]: Popover
	},
	data() {
		return {
			currentStatus: {},
			statusList: [],
			form:{
				disb_full_date:''
			}
		}
	},
	computed: {
		...mapState(useLoanCaseStore, ['activeCase']),
		...mapState(useCommonStore, ['allStatus']),
		is_loading(){
			return _gHlp.isEmpty(this.activeCase)
		},
		remaining_amount() {
			return parseFloat(_gHlp.getValue(this.activeCase, 'loan_amount', 0)) - parseFloat(_gHlp.getValue(this.activeCase, 'disb_done_amt', 0));
		}
	},
	watch: {
		'activeCase': {
			handler(newValue, oldValue) {
				this.setStatusList()
				if(!_gHlp.isEmpty(newValue)){
					this.form.disb_full_date = cloneDeep(newValue.disb_full_date)
				}
			},
			immediate: true
		},
		'allStatus': {
			handler(newValue, oldValue) {
				this.setStatusList()
			},
			immediate: true
		}
	},
	methods: {
		...mapActions(useApprovalStore, ['createApproval']),
		...mapActions(useNotificationStore, ['createBellNotif']),
		...mapActions(useMessagingStore, ['createSendEmail']),
		setStatusList() {
			if (!_gHlp.isEmpty(this.allStatus)) {
				this.statusList = this.allStatus.filter(itm => itm.module == 'disbursement');
				this.setCurrentStatus();
			}
		},
		setCurrentStatus() {
			if (!_gHlp.isEmpty(this.allStatus) && !_gHlp.isEmpty(this.activeCase)) {
				this.currentStatus = this.allStatus.find(itm => itm.id == this.activeCase.disb_status_id);
			}
			if (_gHlp.isEmpty(this.currentStatus)) {
				this.currentStatus = { id: null, name: "No Status", color_class: "text-grey" }
			}
		},
		updateFullDisbDate() {
			let disb_full_date = this.form.disb_full_date;
			if(_gHlp.isEmpty(disb_full_date)) return false;
			
			swal.fire({
				title: 'Full Disbursement Date Change',
				text: "Confirm change to " + disb_full_date,
				showCancelButton: true,
				confirmButtonColor: '#13663E',
				cancelButtonColor: '#8898aa',
				confirmButtonText: 'Confirm',
				reverseButtons: true,
				customClass: {
					title: 'text-left',
					container: 'text-left',
					htmlContainer: 'text-left',
					actions: 'w-100 pr-4 justify-content-end'
				}
			}).then((result) => {
				if (result.isConfirmed) {
					const params = {
						table_name: 'loan_case',
						table_key: 'case_id',
						table_id: this.activeCase.case_id,
						data_reject: null,
						data_approve: {
							disb_full_date: _gHlp.formatDate(disb_full_date,'Y-m-d')
						},
						message: 'Pending Approval : Full disbursement date change to <b>"' + disb_full_date + '</b>" by ' + _gAuth.activeUser('name', ''),
						approve_type: 'Disbursement Approval',
						custom_key: 'CASE_' + this.activeCase.case_id,
						approve_status: 'Pending',
						submit_at: _gHlp.getCurrentDateTime(),
						submit_by: _gAuth.activeUser('id', null)
					}
					this.createApproval(params).then(res => {
						this.createBellNotif('',{
								disb_full_date:disb_full_date,
								user_name:_gAuth.activeUser('name'),
								case_id:this.activeCase.case_id,
								customer_name:this.activeCase.name,
								noti_url: window.location.origin +'/credit-loan-case/detail/'+this.activeCase.case_id+'?active=disbursement',
								noti_related_type: 'loan_case',
								noti_related_id: this.activeCase.case_id
						},
						'Disbursement: customer {customer_name} request full disbursement date change to {disb_full_date} by {user_name}')

						gEventBus.$emit('refresh-approval')
						_gNotif.notifySuccess('<b>Disbursement: </b> - Approval request for change full disbursement date has been submitted.');
					}).catch(err => {
					});
				}
			})
		},
	}	
}
</script>